module.exports = __webpack_public_path__ + "static/media/favourite-unfilled.30537912.svg";